import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, IApprovalStrategy, ContextualField, PropertyType } from '../../../models/index';
import { IStoreService } from '../../../services/index';
import { Helper, strategySaved } from '../../../common/';
import { StoreElement, Store } from '../../../stateManagement';

class ApprovalStrategiesContextualController implements angular.IComponentController {
    properties: ContextualField[];
    isLoading: boolean;
    selectedItem: IApprovalStrategy;
    strategies: IApprovalStrategy[];

    static $inject = ['$rootScope', 'storeService'];

    private _unsubscribe: () => void;

    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.initProperties();
        this._unsubscribe = this._storeService.register(
            store => this.refreshStore(store),
            [StoreElement.ApprovalStrategies]
        );
    }

    $onDestroy() {
        this._unsubscribe();
    }

    private initProperties() {
        this.properties = [
            {
                modelName: 'name',
                propertyName: 'nameProperty',
                propertyType: PropertyType.Text,
                label: 'Name',
                icon: 'fa-id-badge',
                required: true,
                messages: [
                    { key: 'required', value: 'A name is required' },
                    { key: 'duplicate', value: 'This name is already in use' }
                ],
                isValid: value => {
                    const isDuplicate = !this.strategies.length
                        || (!_.some(this.strategies, s => s.guid !== this.selectedItem.guid
                                && s.name.toLowerCase() === value.toLowerCase()));

                    return Helper.getDictionnary<boolean>([{ key: 'duplicate', value: isDuplicate}]);
                }
            }, {
                modelName: 'shortComment',
                propertyName: 'shortCommentProperty',
                propertyType: PropertyType.Text,
                label: 'Short comment',
                icon: 'fa-comment-o',
                maxLength: 16,
                required: false,
                messages: [ { key: 'maxlength', value: 'Short comment can have maximum 16 characters' } ]
            }, {
                modelName: 'longComment',
                propertyName: 'longCommentProperty',
                propertyType: PropertyType.Text,
                label: 'Long comment',
                icon: 'fa-commenting-o',
                required: false
            }, {
                modelName: 'undoApproval',
                propertyName: 'undoApprovalProperty',
                propertyType: PropertyType.Boolean,
                icon: 'fa-undo',
                label: 'Undo approval',
                required: false
            }, {
                modelName: 'allowInFuture',
                propertyName: 'allowInFutureProperty',
                propertyType: PropertyType.Boolean,
                icon: 'fa-fast-forward',
                label: 'Approval of future data',
                required: false
            }
        ];
    }

    private refreshStore(store: Store) {
        this.strategies = _.values(store.approvalStrategies.dictionary);
    }

    save() {
        return this._storeService.dispatchers().approvalStrategy
            .update(this.selectedItem)
            .then(() => this._$rootScope.$broadcast(strategySaved));
    }
}

export const wtApprovalStrategiesContextual: ComponentDefinition = {
    componentId: 'wtApprovalStrategiesContextual',
    controller: ApprovalStrategiesContextualController,
    template: require('./approvalStrategiesContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedItem: '=',
        formController: '=?',
        externalFormController: '<?'
    }
};